import * as api from '../_utils/api';

export class PaymentApi {

    static async createPaymentIntent(artifactId: number): Promise<any> {
        return api._post(`payment/${artifactId}`);
    }
}
